import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { MappingService } from 'app/core/services/mapping.service';

@Component({
  selector: 'guide-video',
  templateUrl: './guide-video.component.html',
  styleUrls: []
})

export class GuideVideoComponent implements OnInit{
  activePath: any = window.location.pathname;
  constructor(public mapping: MappingService, private router: Router,) {

  }
  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Get the current route's URL and update window.location.pathname
      this.activePath = this.router.url;
        console.log('current url',this.activePath);
      }
    });
  }

  onVideoLoad() {
    // Hide loader when the video has loaded
    setTimeout(() => {
        if(this.mapping.videoSrc)
        this.mapping.isVideoLoad = false;
    }, 1500)
}

}
